import React from "react";

import classnames from "classnames";

import { Title as H1 } from "Cobalt/Header";
import BodyText from "Common/BodyText";
import { CardSection } from "Common/Card";

import makeBem from "Utils/makeBem";

const bem = makeBem("DashboardHeader");
type DashboardHeaderProps = {
  title: string;
  subtitle?: string;
  className?: string;
  children?: React.ReactNode;
};

const DashboardHeader = ({ title, subtitle, children, ...rest }: DashboardHeaderProps) => (
  <CardSection className={classnames(bem(), rest.className)} {...rest}>
    <H1 className={classnames(bem("Title"))}>{title}</H1>
    <BodyText weight="normal" mt={2}>
      {subtitle}
    </BodyText>
    {children}
  </CardSection>
);

export default DashboardHeader;
